import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Experts from "@/pages/Experts";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/experts/")({
  head: () => seoHead("/experts/"),
  component: () => (
    <AuthGate><Experts /></AuthGate>
  ),
});
